
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/cost",
      function () {
        return require("private-next-pages/cost.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/cost"])
      });
    }
  